import '../Content/css/public.css'
import '../Content/css/font-awesome.css'
//import '../Content/site/css/grid.css'
//import '../Content/site/css/nav.css'
//import '../Content/site/css/fonts.css'
//import '../Content/site/css/header-animate.css'
//import '../Content/js/html5shiv.min.js'
//import '../Content/js/header.js'

$(function() {
	var navmenu = $(".nav-menu"),
		navmenulist = $(".nav-menu-li"),
		mobile_language_title = $(".mobile-language-title"),
		mobile_language_content = $("mobile-language-content"),
		world = $(".world"),
		nav_product_a = $(".nav-product a");
	var hheight = window.innerHeight;
	var wweith = window.innerWidth;
	nav_product_a.onmouseover = function() {
		$(this).find('img').addClass("nav-menu-scale").removeClass("nav-menu-scale-back");
	}
	nav_product_a.onmouseleave = function() {
		$(this).find('img').removeClass("nav-menu-scale").addClass("nav-menu-scale-back");
	}
	world.onmouseover = function() {
		$(".world-content").slideDown(100);
	}
	world.onmouseleave = function() {
		$(".world-content").hide();
	}
	$("div.language").bind('click', function() {
		$(this).find("ul").slideToggle();
		$(this).addClass("language-bg");
	});
	$("div.language").bind('mouseleave', function() {
		$(this).find("ul").slideUp();
		$(this).removeClass("language-bg");
	});

	$(".mob-button button").on("click", function() {
		$(".moble-nav").css('height', hheight - 60);
		$(".moble-nav").slideToggle();
		if($("button").hasClass("close")) {
			$("button").removeClass("close");
			//$("html,body").removeClass("mask");
		} else {
			$("button").addClass("close");
			//$("html,body").addClass("mask");
		}
	});
	mobile_language_title.on('click', function() {
		if($(this).find('.fa').hasClass('arrow-vertical')) {
			$(this).find('.fa').removeClass("arrow-vertical").addClass("arrow-vertical-back");
			$(this).next('.mobile-language-content').slideUp(100);
			navmenu.slideDown();
		} else {
			$(this).find('.fa').addClass("arrow-vertical").removeClass("arrow-vertical-back");
			$(this).next('.mobile-language-content').slideDown(100);
			navmenu.slideUp();
		}
	});

	$(".navmenu").on('click', function() {
		if($(this).next(navmenulist).hasClass("nav-product")) {
			return undefined;
		} else {
			$(this).next(navmenulist).slideToggle(300);
		}
		if($(this).find('.nav-menu-icon').hasClass('nav-menu-rotate')) {
			$(this).find('.nav-menu-icon').removeClass("nav-menu-rotate").addClass("nav-menu-rotate-back");
		} else {
			$(this).find('.nav-menu-icon').addClass("nav-menu-rotate").removeClass("nav-menu-rotate-back");

		}
	});
	$(".foot-list h4").bind("click", function() {
		$(this).next().slideToggle(400);
	});

	function BackGroundHeight(imgh, w, name) {
		if(window.innerWidth <= w && $(name)) {
			return $(name).height((window.innerWidth / w) * imgh);
		}
	}
	function bg() {
		BackGroundHeight(685, 1200, ".fit-bg");
	}
	$(function() {
		bg();
	});
	window.onresize = function() {
		bg();
	}
	if($("#gotoTop")) {
		var l = $("#gotoTop").offset().left;

		function gotoTop(min_height) {
			$("#gotoTop").click( //定义返回顶部点击向上滚动的动画
				function() {
					$('html,body').animate({
						scrollTop: 0
					}, 500);
					$(".func_box a:eq(0)").addClass("current");
				}).hover( //为返回顶部增加鼠标进入的反馈效果，用添加删除css类实现
				function() {
					// 鼠标移上去的事件
					$(this).addClass("gotoTopHover");
					$(".gotoTopTip").fadeIn();
				},
				function() {
					// 鼠标移除的事件
					$(this).removeClass("gotoTopHover");
					$(".gotoTopTip").fadeOut();
				}
			);
			//获取页面的最小高度，无传入值则默认为600像素
			min_height ? min_height = min_height : min_height = 100;
			//为窗口的scroll事件绑定处理函数
			$(window).scroll(function() {
				//获取窗口的滚动条的垂直位置
				var s = $(window).scrollTop();
				//当窗口的滚动条的垂直位置大于页面的最小高度时，让返回顶部元素渐现，否则渐隐
				if(s > min_height) {
					$("#gotoTop").fadeIn(100);
					$("#gotoTop").css("position", "fixed");
					$("#gotoTop").css("left", l);
				} else {
					$("#gotoTop").fadeOut(200);
				};
			});
		};
		var ie6 = !window.XMLHttpRequest;
		if(ie6) {
			document.getElementById("gotoTop").style.display = "none";
		} else {
			gotoTop();
		}
	}
	if(window.innerWidth > 768) {
		var a = $(".world-content a");
		for(var i = 0; i < a.length; i++) {
			var a_href = a.eq(i).attr('href');
			if(a_href == "http://nz.airwheel.net") {
				a.eq(i).css('width', '135px');
			}
			if(a_href == "http://sa.airwheel.net") {
				a.eq(i).css('width', '135px');
			}
		}
		var a_href = window.location.href,
			$nav_menu = $("header .navication #navbar-toggle .nav-menu");
		if(a_href.indexOf("ru") != -1||a_href.indexOf("fr") != -1) {
			$nav_menu.css("padding", "0 3%");
			$("header .navication #navbar-toggle .nav-menu .nav-menu-li .nav-menu-content a,.index-foot").css("font-family","latolight,arial");	
		}
		if(a_href.indexOf("sp") != -1||a_href.indexOf("jp") != -1) {
			$nav_menu.css("padding", "0 4%");
		}
	}

	//	if($(".product-nav")) {
	//		$(window).on('scroll',function(){
	//			productnav();
	//		})
	//	}
	//	function productnav() {
	//		var wwidth = window.innerWidth;
	//		if(wwidth > 760) {
	//			if($(window).scrollTop() >= 55) {
	//				$(".product-nav").addClass("fixedNav");
	//			} else {
	//				$(".product-nav").removeClass("fixedNav");
	//			}
	//		}
	//	}

})


// WEBPACK FOOTER //
// ./E:/airwheel.net/entry/common.js